export const viewBoardMaster = (state = [], action) => {
  switch (action.type) {
    case "VIEW_BOARD_MASTER":
      return action.payload.data;
    default:
      return state;
  }
};
